function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.2502 1.80005V4.50005C11.2502 4.9971 11.6531 5.40005 12.1502 5.40005H14.8502M6.30015 5.40005H8.10015M6.30015 8.10005H11.7002M6.30015 10.8H11.7002M13.5002 3.15005C13.0996 2.79165 12.6839 2.36658 12.4215 2.09051C12.2469 1.9068 12.0057 1.80005 11.7522 1.80005H4.94994C3.95583 1.80005 3.14995 2.60593 3.14994 3.60004L3.14987 14.4C3.14987 15.3941 3.95575 16.2 4.94986 16.2L13.0499 16.2C14.044 16.2 14.8499 15.3942 14.8499 14.4001L14.8501 4.85842C14.8501 4.62829 14.7624 4.40707 14.6026 4.2414C14.3073 3.93503 13.8141 3.43094 13.5002 3.15005Z",
    stroke: "#C7C5D1",
    style: {
      stroke: "#C7C5D1",
      stroke: "color(display-p3 0.7804 0.7725 0.8196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/Doc.b870a503a2d42815ff70fc3b4d7bfae6.svg";
export { ForwardRef as ReactComponent };